import { render, staticRenderFns } from "./CadastroModeloDistCentroCusto.vue?vue&type=template&id=73ba07bb&scoped=true&"
import script from "./CadastroModeloDistCentroCusto.vue?vue&type=script&lang=js&"
export * from "./CadastroModeloDistCentroCusto.vue?vue&type=script&lang=js&"
import style0 from "./CadastroModeloDistCentroCusto.vue?vue&type=style&index=0&id=73ba07bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ba07bb",
  null
  
)

export default component.exports